const bytesToMB = (bytes: number, decimals = 2): { value: number, measurement: string } => {
  if (bytes < 0) {
    throw new Error('bytesToMB: byte value cannot be negative');
  }
  const mb = bytes / (1024 * 1024);
  if (mb < 1) {
    return { value: MBToKB(mb, 0), measurement: 'KB' };
  }
  return { value: parseFloat(mb.toFixed(decimals)), measurement: 'MB' };
};

const MBToKB = (mb: number, decimals = 0): number => {
  if (mb < 0) {
    throw new Error('MBtoKB: MB value cannot be negative');
  }
  const kb = mb * 1024;
  return parseFloat(kb.toFixed(decimals));
};

const bytesToKB = (bytes: number, decimals = 2): { value: number, measurement: string } => {
  if (bytes < 0) {
    throw new Error('bytesToKB: byte value cannot be negative');
  }
  const kb = bytes / 1024;

  return { value: parseFloat(kb.toFixed(decimals)), measurement: 'KB' };
};

const numberFormats = new Map<string, Intl.NumberFormat>();

/**
 * A shared `Intl.NumberFormat` for the given locale and options. Creating one costs about 0.6 ms on the warehouse
 * PDAs, a hundred times a format call, and pipes and template helpers format on every change detection, so the
 * formats are reused.
 */
const numberFormat = (locale: string, options: Intl.NumberFormatOptions = {}): Intl.NumberFormat => {
  const key = `${locale}|${JSON.stringify(options)}`;
  let format = numberFormats.get(key);
  if (!format) {
    format = new Intl.NumberFormat(locale, options);
    numberFormats.set(key, format);
  }
  return format;
};

export {
  bytesToMB, bytesToKB, numberFormat,
};
